import { isAxiosError, isCancel } from 'axios';
import React from 'react';
import ErrorNetworkPage from '@pages/ErrorPage/ErrorNetworkPage';
import ErrorPage500 from '@pages/ErrorPage/ErrorPage500';

const importModuleErrors: readonly string[] = [
  'Failed to fetch dynamically imported module',
  'Failed to load module script',
  'error loading dynamically imported module',
  // Vite's preload helper, as patched by vite-plugins/inject-csp.mts
  'Unable to preload'
];

export default class ErrorBoundary extends React.Component<React.PropsWithChildren> {
  state = { hasError: false, isNetworkError: false };

  static getDerivedStateFromError(err: any) {
    let isNetworkError = false;
    if (isAxiosError(err)) {
      const { response } = err;
      isNetworkError = !response && !isCancel(err);
    } else if (err instanceof Error) {
      isNetworkError = importModuleErrors.some((x) => err.message.includes(x));
    }
    return { hasError: true, isNetworkError };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    try {
      const { uxpHost } = window as any;
      if (uxpHost) {
        uxpHost.postMessage({
          type: 'error',
          message: error.message,
          stack: error.stack,
          componentStack: errorInfo.componentStack,
          digest: errorInfo.digest
        });
      }
    } catch {
      // ignore
    }
  }

  render() {
    if (this.state.hasError) {
      return this.state.isNetworkError ? (
        <ErrorNetworkPage />
      ) : (
        <ErrorPage500 />
      );
    }
    return this.props.children;
  }
}
